(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('StatTechnicien', StatTechnicien);

    StatTechnicien.$inject = ['$resource'];

    function StatTechnicien ($resource) {
        var resourceUrl =  'api/stat-techniciens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
